export default "__VITE_ASSET__Dg9xLPGq__"